export default __webpack_public_path__ + "static/media/download.2ecdbf80.png";